var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "el_dialog",
      attrs: {
        "close-on-press-escape": false,
        "custom-class": "layout-dialog",
        title: "各種データダウンロード",
        top: "5vh",
        width: "580px",
        visible: _vm.dialogVisible2,
        "append-to-body": "",
      },
      on: { close: _vm.close },
    },
    [
      _vm._l(_vm.list, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "flex_colum",
            class: index + 1 == _vm.list.length ? "" : "dialog_item",
          },
          [
            item.title
              ? _c("div", { staticClass: "text_84" }, [
                  _vm._v(_vm._s(item.title)),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "flex_center_align" },
              [_c("vab-button", { attrs: { "btn-list": item.buttonList } })],
              1
            ),
          ]
        )
      }),
      _c(
        "div",
        {
          staticClass: "dialog-footer flex_end mg12",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "flex_start flex_center_align" },
            [_c("vab-button", { attrs: { "btn-list": _vm.btnList } })],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }